import React from 'react'
import cx from 'classnames'
import './style'

const Wood = () => (
    <div
        className={cx(
            'Wood',
            'abF',
        )}
    />
)

export default Wood
